export const CustomerStatusesConstants = {
  new: "新規",
  existed: "既存",
  defection: "離反",
  hibernation: "休眠",
  revisited: "再来",
};
